"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const provinceAbbreviations = {
    alberta: 'ab',
    'british columbia': 'bc',
    saskatchewan: 'sk',
    manitoba: 'mb',
    ontario: 'on',
    quebec: 'qc',
    'new brunswick': 'nb',
    'nova scotia': 'ns',
    'prince edward island': 'pe',
    'newfoundland and labrador': 'nl',
    'northwest territories': 'nt',
    yukon: 'yt',
    nunavut: 'nu',
};
const gst = 5;
const taxRates = {
    bc: { pst: 7, gst },
    ab: { gst },
    sk: { pst: 6, gst },
    mb: { gst },
    on: { hst: 13 },
    qc: { pst: 9.975, gst },
    nb: { hst: 15 },
    ns: { hst: 15 },
    pe: { hst: 15 },
    nl: { hst: 15 },
    nt: { gst },
    yt: { gst },
    nu: { gst },
};
class TaxRateNotFoundError extends Error {
}
exports.TaxRateNotFoundError = TaxRateNotFoundError;
exports.getTaxRate = (province) => {
    const prov = province.toLowerCase();
    if (prov in provinceAbbreviations) {
        return taxRates[provinceAbbreviations[prov]];
    }
    return taxRates[prov];
};
exports.calculateTax = (province, amountCents) => {
    const rate = exports.getTaxRate(province);
    if (!rate) {
        throw new TaxRateNotFoundError(`Couldnt find tax rate for ${province}`);
    }
    const { pst, gst, hst } = rate;
    return {
        pstCents: pst ? Math.round(amountCents * (pst / 100)) : 0,
        gstCents: gst ? Math.round(amountCents * (gst / 100)) : 0,
        hstCents: hst ? Math.round(amountCents * (hst / 100)) : 0,
    };
};
exports.calculateProvincialSalesTaxCents = (province, amountCents) => {
    const { pstCents, gstCents, hstCents } = exports.calculateTax(province, amountCents);
    return pstCents + gstCents + hstCents;
};
//# sourceMappingURL=data:application/json;base64,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